<template>
  <div>
    <CourseVideoPlaceholderBoard>
      <template #title>
        <span class="d-none d-sm-block">Por que parar no começo da jornada?</span>
      </template>

      <template #subtitle class="mt-0">
        Tenha acesso a <u>todos</u> os cursos e materiais exclusivos para membros CyberClass!
      </template>
    </CourseVideoPlaceholderBoard>

    <div class="mt-sm-5 mt-4 d-flex flex-column align-items-center">
      <LandingButton class="button button--primary button--size-md" @click="redirect">
        QUERO SABER MAIS
      </LandingButton>

      <span class="mt-1 mb-1 mb-md-3 mt-md-3 normal-text">ou</span>
      
      <LandingButton class="button button--size-md" @click="openAuthModal">
        JÀ SOU ASSINANTE
      </LandingButton>
    </div>
  </div>
</template>

<script>
import CourseVideoPlaceholderBoard from '@/components/course/video-placeholder/CourseVideoPlaceholderBoard'
import LandingButton from '@/components/buttons/LandingButton.vue'
import AuthFormModal from '@/components/modals/auth/AuthFormModal'

export default {
  components: {
    CourseVideoPlaceholderBoard,
    LandingButton,
  },

  props: ['courseId', 'courseClassId'],

  mounted () {
    this.$gtm.trackEvent({ event: 'course-preview', target: 'course', action: 'end', item_id: this.courseId })
    this.$gtm.trackEvent({ event: 'course-preview', target: 'class', action: 'end', item_id: this.courseClassId })
  },

  methods: {
    redirect () {
      this.$gtm.trackEvent({ event: 'course-preview', target: 'course', action: 'click-landing', item_id: this.courseId })
      this.$gtm.trackEvent({ event: 'course-preview', target: 'class', action: 'click-landing', item_id: this.courseClassId })

      this.$router.push({ name: 'subscribe' })
    },

    openAuthModal () {
      this.$gtm.trackEvent({ event: 'course-preview', target: 'course', action: 'click-auth', item_id: this.courseId })
      this.$gtm.trackEvent({ event: 'course-preview', target: 'class', action: 'click-auth', item_id: this.courseClassId })

      this.$modal.show(AuthFormModal, { defaultTab: 'sign-in' }, { width: '343px' }, {
        'closed': () => this.$store.commit('auth/resetModal')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .button {
    font-size: 14px;
  }

  .normal-text {
    color: #fff;
    font-weight: 700;

  }
</style>